/** Upload card status */
export enum UploadCardStatus {
  Complete = 'Complete',
  Error = 'Error',
  Pending = 'Pending',
  Processing = 'Processing',
  Queued = 'Queued',
  UploadPending = 'UploadPending',
  Uploading = 'Uploading',
  Warning = 'Warning',
}
